import { FieldTypes } from '../../../constants/FieldTypes'
import { addCondition, addFieldRow } from '../../../fields/utils'
import {
  CheckboxField,
  DropdownField,
  FieldMap,
  FormElement,
  NumberField,
} from '../../../types/forms/fields'
import { FieldEncounterSection } from '../types/encounter'

const collectionField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  options: [
    { id: 'declined', text: 'Declined' },
    { id: 'ua-not-indicated', text: 'UA Not Indicated' },
    { id: 'clean-catch', text: 'Clean Catch' },
  ],
  placeholder: 'Collection',
  optional: true,
}

const proteinField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  options: [
    { id: 'negative', text: 'Negative' },
    { id: 'trace', text: 'Trace' },
    { id: '1+', text: '1+' },
    { id: '2+', text: '2+' },
    { id: '3+', text: '3+' },
    { id: '4+', text: '4+' },
  ],
  placeholder: 'Protein',
  optional: true,
}

const glucoseField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  options: [
    { id: 'negative', text: 'Negative' },
    { id: 'trace', text: 'Trace' },
    { id: '100mg/dL', text: '100mg/dL' },
    { id: '200mg/dL', text: '200mg/dL' },
    { id: '300mg/dL', text: '300mg/dL' },
    { id: '400mg/dL', text: '400mg/dL' },
    { id: '500mg/dL', text: '500mg/dL' },
    { id: '>500mg/dL', text: '>500mg/dL' },
  ],
  placeholder: 'Glucose',
  optional: true,
}

const ketonesField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  options: [
    { id: 'negative', text: 'Negative' },
    { id: 'trace', text: 'Trace' },
    { id: 'small', text: 'Small' },
    { id: 'moderate', text: 'Moderate' },
    { id: 'large', text: 'Large' },
  ],
  placeholder: 'Ketones',
  optional: true,
}

const bilirubinField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  options: [
    { id: 'negative', text: 'Negative' },
    { id: '1+', text: '1+' },
    { id: '2+', text: '2+' },
    { id: '3+', text: '3+' },
  ],
  placeholder: 'Bilirubin',
  optional: true,
}

const bloodField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  options: [
    { id: 'negative', text: 'Negative' },
    { id: 'trace', text: 'Trace' },
    { id: 'small', text: 'Small' },
    { id: 'moderate', text: 'Moderate' },
    { id: 'large', text: 'Large' },
  ],
  placeholder: 'Blood',
  optional: true,
}

const nitritesField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  options: [
    { id: 'negative', text: 'Negative' },
    { id: 'positive', text: 'Positive' },
  ],
  placeholder: 'Nitrites',
  optional: true,
}

const leukocyteEsteraseField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  options: [
    { id: 'negative', text: 'Negative' },
    { id: 'trace', text: 'Trace' },
    { id: 'small', text: 'Small' },
    { id: 'moderate', text: 'Moderate' },
    { id: 'large', text: 'Large' },
  ],
  placeholder: 'Leukocyte Esterase',
  optional: true,
}

const phField: NumberField = {
  type: FieldTypes.NUMBER,
  placeholder: 'pH',
  min: 0,
  max: 14,
  step: 0.1,
  precision: 1,
  optional: true,
}

export const urineExamField: FieldMap = {
  name: 'Urine Exam',
  children: {
    collection: collectionField,
    protein: addFieldRow(proteinField, { index: 0, flex: 1 }),
    nitrites: addFieldRow(nitritesField, { index: 2, flex: 1 }),
    glucose: addFieldRow(glucoseField, { index: 0, flex: 1 }),
    ph: addFieldRow(phField, { index: 3, flex: 1 }),
    ketones: addFieldRow(ketonesField, { index: 1, flex: 1 }),
    bilirubin: addFieldRow(bilirubinField, { index: 1, flex: 1 }),
    blood: addFieldRow(bloodField, { index: 2, flex: 1 }),
    leukocyteEsterase: addFieldRow(leukocyteEsteraseField, { index: 3, flex: 1 }),
  },
}

export const hasUrineExamField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Urine Exam',
  size: 'lg',
}

export const getUrineExamSection: (optional: boolean) => FieldEncounterSection = optional => {
  const children: Record<string, FormElement> = {}
  if (optional) {
    children.hasUrineExam = hasUrineExamField
    children.urine = addCondition(urineExamField, v => !!v?.hasUrineExam)
  } else {
    children.urine = urineExamField
  }
  return { type: 'field', field: { name: 'Urine Exam', children } }
}
